<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>盘点列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待盘点</el-radio-button>
                    <el-radio-button label="1">待接收</el-radio-button>
                    <el-radio-button label="2">待审批</el-radio-button>
                    <el-radio-button label="3">已调整</el-radio-button>
                    <el-radio-button label="4">已退回</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="backClick()" :disabled="recvBtnDis && chkBtnDis">退回</el-button>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(2)" :disabled="chkBtnDis">审批</el-button>
                <span>-</span>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(1)" :disabled="recvBtnDis">接收</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDrawer">新增盘点</el-button>
                <span>-</span>
            </p>
        </div>

        <el-table :data="inventoryCheckList" style="width: 100%" @select="selectClick" @row-click="rowClick"
            ref="outStockTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="inventoryCheckCode" label="盘点编号" min-width="18%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="30%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>

            <el-table-column prop="createdTime" label="申请日期" min-width="12%">
            </el-table-column>
            <el-table-column prop="applicant" label="申请人" min-width="10%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="20%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.status == '待盘点' ? true : false">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="盘点详情" :visible.sync="drawerVisible" size="80%" style="text-align: left;">

            <div style="padding: 0 10px;">
                <p style="display:inline-block;width:80px;text-align: center;">申请日期</p>
                <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期" disabled="true">
                </el-date-picker>

                <p style="display:inline-block;width:80px;text-align: center;">备注</p>
                <el-input placeholder="请输入" v-model="form.remark" clearable style="display:inline-block;width:450px"
                    :disabled="!applyCheckShow"></el-input>

                <p style="display:inline-block;width:80px;text-align: center;">仓库</p>
                <el-select v-model="form.storeId" placeholder="请选择" style="width:120px">
                    <el-option v-for="item in form.storeList" :key="item.value" :label="item.storeName"
                        :value="item.id">
                    </el-option>
                </el-select>

                <p style="display:inline-block;width:80px;text-align: center;" v-if="applyCheckShow">添加产品</p>
                <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                    :remote-method="searchProduct" :loading="loading" v-if="applyCheckShow">
                    <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                        :value="item.productId">
                    </el-option>
                </el-select>

                <el-button type="primary" @click="addProduct" v-if="applyCheckShow">添加</el-button>
            </div>

            <div style="padding:10px;margin-bottom: 20px;">
                <el-table :data="inventoryCheckProductList" show-summary>
                    <el-table-column prop="productCode" label="产品条码" min-width="15%">
                    </el-table-column>
                    <el-table-column prop="productName" label="产品名称" min-width="25%">
                    </el-table-column>
                    <el-table-column prop="stockQuantity" label="库存数量" min-width="9%">
                    </el-table-column>

                    <el-table-column prop="checkQuantity" label="盘点数量" min-width="22%">
                        <template inline-template slot-scope="scope">
                            <el-input-number v-model="scope.row.checkQuantity" :step="1" :min="0"
                                :disabled="productItemDisabled" style="width:190px"></el-input-number>
                        </template>
                    </el-table-column>

                    <el-table-column prop="quantity" label="盈亏数量" min-width="9%">
                        <template inline-template slot-scope="scope">
                            <label>{{ scope.row.checkQuantity - scope.row.stockQuantity }}</label>
                        </template>

                    </el-table-column>

                    <el-table-column prop="productRemark" label="备注" min-width="20%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.productRemark" size="mini"
                                :disabled="productItemDisabled"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="90">
                        <template slot-scope="scope">
                            <el-button @click="removeProduct(scope.row)" type="danger" round size="small"
                                :disabled="delBtnDisable">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div>
                <div style="margin-left: 40%;">
                    <el-button type="primary" round @click="addInventoryCheck" v-if="saveBtnShow">保存</el-button>

                    <el-button type="primary" round @click="editClick" v-if="!saveBtnShow && editBtnShow">盘点</el-button>
                </div>
            </div>

            <div>
                <p style="margin-left:20px;font-weight:bold">流转日志</p>
                <div style="padding:10px;">
                    <el-table :data="logList">
                        <el-table-column prop="createdTime" label="操作时间" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operationType" label="操作类型" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operator" label="操作人" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="remark" label="操作说明" min-width="25%">
                        </el-table-column>
                    </el-table>
                </div>
            </div>

        </el-drawer>

        <el-dialog title="退回" :visible.sync="dialogVisible">
            <p style="display:inline-block;width:80px;text-align: center;">退回原因：</p>
            <el-input placeholder="请输入" v-model="backRemark" clearable
                style="display:inline-block;width:400px"></el-input>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBack">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "InventoryCheck",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            recvBtnDis: true,
            chkBtnDis: true,

            inventoryCheckList: [],

            drawerVisible: false,
            dialogVisible: false,

            statusSearch: 0,
            form: {
                id: '',
                inventoryCheckCode: '自动生成',

                productList: [],
                productId: '',
                productName: '',

                storeId: '',
                storeList: [],

                createdTime: new Date(),
                status: 0,
                remark: ''
            },

            loading: false,
            formLabelWidth: '120px',

            inventoryCheckProductList: [],
            productItemDisabled: true,
            delBtnDisable: false,
            logList: [],

            applyCheckShow: true,
            saveBtnShow: true,
            editBtnShow: false,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,

            checkQuantity: '',
            backRemark: ''
        }
    },
    methods: {
        addProduct() {
            // console.log('add')
            // console.log(this.form.productName)

            const index = this.form.productList.findIndex(obj => obj.productId == this.form.productName)

            // console.log(this.form.productList[index])

            this.inventoryCheckProductList.push(this.form.productList[index])
        },
        removeProduct(row) {
            // console.log('remove')
            // console.log(row)

            const index = this.inventoryCheckProductList.findIndex(obj => obj.productId == row.productId)

            this.inventoryCheckProductList.splice(index, 1)
        },
        getAllStockProduct(val) {
            this.$axios({
                method: "post",
                url: "/shiro/product/stock/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex: -1,
                    pageNum: -1
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data
            })
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getAllStockProduct(val)
                }, 200)

            } else {
                this.form.productList = []
            }
        },
        selectClick(selection, row) {

            this.$refs.outStockTable.clearSelection()
            this.$refs.outStockTable.toggleRowSelection(row)

            this.form.id = row.id
            this.form.status = row.status

            if (row.status == '待接收') {
                this.recvBtnDis = false
                this.chkBtnDis = true
            } else if (row.status == '待审批') {
                this.recvBtnDis = true
                this.chkBtnDis = false
            } else {
                this.recvBtnDis = true
                this.chkBtnDis = true
            }

        },
        rowClick(row) {
            //console.log(row)

            this.$refs.outStockTable.clearSelection()
            this.$refs.outStockTable.toggleRowSelection(row)

            this.form.id = row.id
            this.form.status = row.status

            if (row.status == '待接收') {
                this.recvBtnDis = false
                this.chkBtnDis = true
            } else if (row.status == '待审批') {
                this.recvBtnDis = true
                this.chkBtnDis = false
            } else {
                this.recvBtnDis = true
                this.chkBtnDis = true
            }

        },
        getInventoryCheckProduct(row) {

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/getOne",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.inventoryCheckProductList = data.data.inventoryCheckProductVOList

                for (let i in this.inventoryCheckProductList) {
                    this.inventoryCheckProductList[i].productRemark = this.inventoryCheckProductList[i].remark
                }

                this.logList = data.data.inOutLogsList
                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].operationType == 0) {
                        this.logList[i].operationType = '申请'
                    } else if (this.logList[i].operationType == 1) {
                        this.logList[i].operationType = ' 接收'
                    } else if (this.logList[i].operationType == 2) {
                        this.logList[i].operationType = ' 审批'
                    } else if (this.logList[i].operationType == 3) {
                        this.logList[i].operationType = '退回'
                    } else {
                        this.logList[i].operationType = '盘点'
                    }
                }

            })
        },
        handleClick(row) {
            // console.log(row)

            this.form.id = row.id

            this.form.inventoryCheckCode = row.inventoryCheckCode

            this.form.createdTime = row.createdTime

            this.form.status = null
            this.form.remark = row.remark

            this.form.productName = ''

            this.drawerVisible = true
            this.productItemDisabled = true
            this.delBtnDisable = true

            this.applyCheckShow = false
            this.saveBtnShow = false
            this.editBtnShow = false

            if (row.status == '待盘点') {
                this.editBtnShow = true
            }

            this.getInventoryCheckProduct(row)

            this.getAllStockProduct('')
        },
        getAllStore() {
            this.$axios({
                method: "post",
                url: "/shiro/base/store/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.storeList = data.data

                if (this.form.storeList.length > 0) {

                    this.form.storeId = this.form.storeList[0].id
                }
            })
        },
        openDrawer() {

            this.form.id = ''
            this.form.inventoryCheckCode = '自动生成'

            this.form.applicant = ''
            this.form.productName = ''

            this.form.status = 0
            this.form.remark = ''

            this.inventoryCheckProductList = []
            this.logList = []

            this.applyCheckShow = true
            this.saveBtnShow = true
            this.productItemDisabled = true
            this.drawerVisible = true

            this.getAllStore()

            this.getAllStockProduct('')
        },
        operateClick(val) {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择盘点单'
                })
                return
            }

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                if (val == 1) {
                    this.receiveClick()
                } else {
                    this.checkClick()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        receiveClick() {

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/receive",
                data: {
                    id: this.form.id,
                    status: 2,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })
        },
        checkClick() {

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/check",
                data: {
                    id: this.form.id,
                    status: 3,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })
        },
        backClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择盘点单'
                })
                return
            }

            if (this.form.status == '已调整' || this.form.status == '已退回') {
                this.$message({
                    type: 'info',
                    message: '当前状态不允许操作'
                })
                return
            }

            this.dialogVisible = true
        },
        confirmBack() {

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/goBack",
                data: {
                    id: this.form.id,
                    status: 4,
                    applicant: this.userId,
                    remark: this.backRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.dialogVisible = false

                this.getAll(this.statusSearch)
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeInventoryCheck(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addInventoryCheck() {

            if (this.form.storeId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择仓库'
                })
                return
            }

            const icpList = []

            // console.log('addInventoryCheck()')
            // console.log(this.inventoryCheckProductList)

            for (let i in this.inventoryCheckProductList) {

                icpList.push({
                    id: this.inventoryCheckProductList[i].id,
                    productId: this.inventoryCheckProductList[i].productId,
                    stockQuantity: this.inventoryCheckProductList[i].stockQuantity,
                    checkQuantity: this.inventoryCheckProductList[i].checkQuantity,
                    remark: this.inventoryCheckProductList[i].productRemark
                })
            }

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/add",
                data: {
                    id: this.form.id,
                    inventoryCheckCode: this.form.inventoryCheckCode,

                    applicant: this.userId,
                    remark: this.form.remark,

                    storeId: this.form.storeId,

                    inventoryCheckProductList: icpList,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })

        },
        editClick() {

            this.productItemDisabled = false

            this.saveBtnShow = true
        },
        printInStock(fang) {
            // console.log('fang')
            // console.log(fang)

            var content = document.getElementById("warehousing-list").innerHTML

            // console.log(content)

            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")

            // console.log('iframe')
            // console.log(iframe)

            var doc = null
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document

            // console.log('doc')
            // console.log(doc)

            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            iframe.contentWindow.addEventListener('load', function () {
                // console.log('addEventListener')

                iframe.contentWindow.print()
                document.body.removeChild(iframe)
            })

        },
        searchByStatus(val) {
            this.recvBtnDis = true
            this.chkBtnDis = true

            this.form.id == ''

            this.getAll(val)
        },
        removeInventoryCheck(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/inventory/check/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll(this.statusSearch)
            })
        },
        getAll(val) {

            this.$axios({
                method: "post",
                url: "/shiro/inventory/check/getAll",
                data: {
                    status: val,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                this.form.id = ''
                this.total = 0

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.inventoryCheckList = data.data
                if (this.inventoryCheckList.length > 0) {
                    this.total = this.inventoryCheckList[0].total
                }

                for (let i in this.inventoryCheckList) {
                    this.inventoryCheckList[i].createdTime = this.$moment(this.inventoryCheckList[i].createdTime).format("YYYY-MM-DD")

                    if (this.inventoryCheckList[i].status == 0) {
                        this.inventoryCheckList[i].status = '待盘点'
                    } else if (this.inventoryCheckList[i].status == 1) {
                        this.inventoryCheckList[i].status = '待接收'
                    } else if (this.inventoryCheckList[i].status == 2) {
                        this.inventoryCheckList[i].status = '待审批'
                    } else if (this.inventoryCheckList[i].status == 3) {
                        this.inventoryCheckList[i].status = '已调整'
                    } else {
                        this.inventoryCheckList[i].status = '已退回'
                    }
                }
            })
        },
        pageClick(currentPage) {
            this.inventoryCheckList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll(this.statusSearch)
        },
    },
    mounted() {
        this.setDefaultPath('/inventoryCheck')

        this.getAll(this.statusSearch)
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>